import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Pagination } from '../../component-pagination';
import { forwardRef } from 'react';
/**
 * `GalleryContentNavigationPagination` component is used to display a pagination within `GalleryContentNavigation`.
 */
export const GalleryContentNavigationPagination = forwardRef(({ ...props }, ref) => _jsx(Pagination, { variant: "page", ...props, ref: ref }));
GalleryContentNavigationPagination.displayName =
    'GalleryContentNavigationPagination';
